module.exports = __webpack_public_path__ + "static/media/CostOpportunity_Diagram_Desktop_EN.b74682b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CostOpportunity_Diagram_Desktop_EN.png
// module id = 572
// module chunks = 0